import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function () {
    const root = document.querySelector(
        '.o-adimplencia__swiper[data-swiper="adimplencia"]',
    );
    if (!root) return;

    const paginationEl = root.querySelector(".o-adimplencia__pagination");

    const slider = new Swiper(root, {
        modules: [Pagination],
        slidesPerView: 1.15,
        spaceBetween: 12,
        autoHeight: true,
        pagination: {
            el: paginationEl,
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 14,
                allowTouchMove: false,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 18,
                allowTouchMove: false,
            },
        },
    });

    return slider;
}
